/** Marketplace peso formatting — whole pesos with thousands separators ("₱1,253"). */
export function peso(value: string | number, opts?: { decimals?: boolean }): string {
  const num = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(num)) return '₱0';
  return (
    '₱' +
    num.toLocaleString('en-PH', {
      minimumFractionDigits: opts?.decimals ? 2 : 0,
      maximumFractionDigits: opts?.decimals ? 2 : 0,
    })
  );
}

/** The original "was" price implied by an effective price + discount %. */
export function wasFromOff(price: number, off: number): number {
  if (off <= 0) return price;
  return Math.round(price / (1 - off / 100));
}

/** "1h 20m" / "35m" from a duration in seconds (course/lesson runtimes). */
export function fmtDuration(secs: number): string {
  const h = Math.floor(secs / 3600);
  const m = Math.round((secs % 3600) / 60);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

/**
 * "1.2k" / "950" — compact follower / product / student counts on a seller
 * panel (the merchant shop page and the instructor page both use it, so a
 * shopper and a learner read the same number the same way).
 */
export function compact(n: number): string {
  return n >= 1000 ? `${(n / 1000).toFixed(1)}k` : String(n);
}

/** "this month" / "3 months ago" / "2 years ago" from an ISO join date. */
export function relativeJoined(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const days = Math.max(0, Math.floor((Date.now() - then) / 86_400_000));
  if (days < 30) return 'this month';
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;
  const years = Math.floor(days / 365);
  return `${years} year${years === 1 ? '' : 's'} ago`;
}
